import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermOfServiceV1Component } from './term-of-service-v1/term-of-service-v1.component';
import { TermOfServiceV1PublicComponent } from './term-of-service-v1-public/term-of-service-v1-public.component';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [TermOfServiceV1Component, TermOfServiceV1PublicComponent],
  imports: [CommonModule, MaterialModule, SharedModule],
})
export class OthersModule {}
